import React from 'react'

import { bool, node, string } from 'prop-types'
import { css } from '@emotion/core'
import { Theme, themes } from '@fs/zion-ui'

export default function PersonDialogBox({ personId, isShowing, children }) {
  const cssBox = () => css`
    display: flex;
    flex-direction: column;
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100%;
    border: 1px solid #000;
    overflow-x: hidden;
    background-color: #fff;
    z-index: 2;

    overflow-y: hidden;
  `
  return isShowing ? (
    <Theme theme={themes.daybreak}>
      <React.Fragment>
        <div css={cssBox} aria-modal aria-hidden tabIndex={-1} role="dialog" data-person={personId}>
          {children}
        </div>
      </React.Fragment>
    </Theme>
  ) : null
}

PersonDialogBox.propTypes = {
  personId: string,
  children: node.isRequired,
  isShowing: bool,
}
